// @flow
/* eslint-disable import/no-cycle */
import _debug from 'debug';
import { makeActionCreator, reduce } from '../helpers/utils';
import { LOAD_LISTING_SUCCESS } from './forms/checkout';
import ApiClient from '../api/Api';

const debug = _debug('jp:reducers:brand');

export const UPDATE_BRAND = 'brand:update_brand';
export const LOAD_PARTNER_WHITELABEL = 'brand:load_partner_whitelabel';
export const LOAD_PARTNER_WHITELABEL_SUCCESS =
  'brand:load_partner_whitelabel_success';
export const LOAD_PARTNER_WHITELABEL_FAIL =
  'brand:load_partner_whitelabel_fail';
export const RESET_BRAND = 'brand:reset_brand';

export type State = {|
  primaryColor: string | null,
  secondaryColor: string | null,
  onPrimaryColor: string | null,
  onSecondaryColor: string | null,
  logo: string | null, // Standard logo for light backgrounds
  logoInverse: string | null, // Logo for darker backgrounds
  isWhiteLabeled: boolean,
  partnerWhiteLabelError: boolean,
  partner: string
|};

export const initialState: State = {
  primaryColor: null,
  onPrimaryColor: null,
  secondaryColor: null,
  onSecondaryColor: null,
  logo: null,
  logoInverse: null,
  isWhiteLabeled: false,
  partnerWhiteLabelError: false,
  partner: ''
};

type Action = {| type: typeof LOAD_LISTING_SUCCESS, payload: any |};

export default reduce<State, Action>(initialState, {
  [UPDATE_BRAND](state: State, action): State {
    debug(UPDATE_BRAND, action);

    return {
      ...state,
      primaryColor: action.primaryColor,
      secondaryColor: action.secondaryColor,
      onPrimaryColor: action.onPrimaryColor,
      onSecondaryColor: action.onSecondaryColor,
      logo: action.logo,
      logoInverse: action.logoInverse,
      isWhiteLabeled: true
    };
  },
  [LOAD_PARTNER_WHITELABEL_SUCCESS](state: State, action: Action): State {
    debug(LOAD_PARTNER_WHITELABEL_SUCCESS, action);

    if (action && action.payload) {
      const {
        primaryColour,
        onPrimaryColour,
        secondaryColour,
        onSecondaryColour,
        logoUrl,
        invertedLogoUrl,
        companyName
      } = action.payload[0];

      return {
        ...state,
        primaryColor: primaryColour,
        secondaryColor: secondaryColour,
        onPrimaryColor: onPrimaryColour,
        onSecondaryColor: onSecondaryColour,
        logoInverse: invertedLogoUrl,
        logo: logoUrl,
        isWhiteLabeled: true,
        partner: companyName.toLowerCase()
      };
    }
    return {
      ...state
    };
  },
  [LOAD_PARTNER_WHITELABEL_FAIL](state: State, action: Action): State {
    debug(LOAD_PARTNER_WHITELABEL_FAIL, action);

    return {
      ...state,
      partnerWhiteLabelError: true
    };
  },
  [LOAD_LISTING_SUCCESS](state: State, action: Action): State {
    debug(LOAD_LISTING_SUCCESS, action);

    if (action.payload && action.payload.data) {
      const listing = action.payload.data;

      if (listing.whiteLabel && !state.isWhiteLabeled) {
        const {
          logoUrl,
          invertedLogoUrl,
          primaryColour,
          secondaryColour,
          onPrimaryColour,
          onSecondaryColour
        } = listing.whiteLabel;

        return {
          ...state,
          primaryColor: primaryColour,
          secondaryColor: secondaryColour,
          onPrimaryColor: onPrimaryColour,
          onSecondaryColor: onSecondaryColour,
          logo: logoUrl,
          logoInverse: invertedLogoUrl,
          isWhiteLabeled: true,
          partner: ''
        };
      }
    }

    return state;
  },
  [RESET_BRAND](state: State): State {
    return {
      ...state,
      ...initialState
    };
  }
});

export const updateBrand = makeActionCreator(
  UPDATE_BRAND,
  'primaryColor',
  'secondaryColor',
  'onPrimaryColor',
  'onSecondaryColor',
  'logo'
);

export function loadPartnerWhiteLabel(partnerName: string) {
  return {
    types: [
      LOAD_PARTNER_WHITELABEL,
      LOAD_PARTNER_WHITELABEL_SUCCESS,
      LOAD_PARTNER_WHITELABEL_FAIL
    ],
    promise: (client: typeof ApiClient) =>
      client.checkout
        .partnerWhiteLabel(partnerName)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e;
        })
  };
}

export const resetBrand = makeActionCreator(RESET_BRAND);
